import React from "react";
import "./circle.scss"; // Assuming the CSS file is named App.css
import SmsOTP from "../Assets/smsOTP";

// Static image path from public folder
const Agent = "/assets/img/Agent.png";

const CircleDesign = () => {
  return (
    <div className="CircleContainer">
      <div className="large-circle">
        <img src={Agent} alt="Agent Image" />
      </div>
      <div className="medium-circle">
        {/* <SmsOTP /> */}
      </div>
      <div className="small-circle"></div>
      <div className="tiny-circle"></div>
    </div>
  );
};

export default CircleDesign;
